export default function ShieldLogo({ size = 44, topText = "PUT CHA", number = "66", className = "" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            className={className}
            data-testid="shield-logo"
            aria-label="Interstate shield logo"
        >
            <path
                d="M50 3 C60 11 76 15 94 13 C94 54 82 79 50 97 C18 79 6 54 6 13 C24 15 40 11 50 3 Z"
                fill="#F6F2E8"
            />
            <path
                d="M50 7 C59 14 73 18 90 16 C90 53 79 76 50 93 C21 76 10 53 10 16 C27 18 41 14 50 7 Z"
                fill="#0055A5"
            />
            <path
                d="M50 7 C59 14 73 18 90 16 C90 24 89.6 30 88.6 36 L11.4 36 C10.4 30 10 24 10 16 C27 18 41 14 50 7 Z"
                fill="#D32F2F"
            />
            <text
                x="50"
                y="30"
                textAnchor="middle"
                fontFamily="'Bebas Neue', sans-serif"
                fontSize="11"
                letterSpacing="1.5"
                fill="#F6F2E8"
            >
                {topText}
            </text>
            <text
                x="50"
                y="74"
                textAnchor="middle"
                fontFamily="'Bebas Neue', sans-serif"
                fontSize="36"
                fill="#F6F2E8"
            >
                {number}
            </text>
        </svg>
    );
}
